
import React from "react";
import styles from "../../assets/style.module.css";

export interface SectionHeaderProps {
    title: string;
    kicker?: string;
    titleEm?: string;
    subtitle?: string;
    as?: "h1" | "h2";
    action?: React.ReactNode;
}

function SectionHeader({ kicker, title, titleEm, subtitle, action, as: Heading = "h2" }: SectionHeaderProps) {
    return (<div className={styles["sec-head"]}>
        <div>
            {kicker && (<div className={styles["kicker"]}>{kicker}</div>)}
            <Heading className={styles["title"]}>{title}{titleEm && (<> <em>{titleEm}</em></>)}</Heading>
            {subtitle && (<p className={styles["sub"]}>{subtitle}</p>)}
        </div>
        {action}
    </div>);
}

export default SectionHeader;
